module.exports = __webpack_public_path__ + "img/potato.e408339f.png";